var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMic24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 51,
    viewBox: "0 0 38 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9687 24.3441C26.9687 28.7534 23.4093 32.3128 18.9999 32.3128C14.5905 32.3128 11.0312 28.7534 11.0312 24.3441V8.40656C11.0312 3.99718 14.5905 0.437805 18.9999 0.437805C23.4093 0.437805 26.9687 3.99718 26.9687 8.40656V24.3441ZM18.9998 37.6253C26.331 37.6253 32.281 31.6753 32.281 24.3441H37.5935C37.5935 33.7206 30.6607 41.4237 21.656 42.7253V50.9065H16.3435V42.7253C7.33882 41.4237 0.406006 33.7206 0.406006 24.3441H5.71851C5.71851 31.6753 11.6685 37.6253 18.9998 37.6253Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic24Px);
export default __webpack_public_path__ + "static/media/mic_24px.6bbfe43cf37a2e951cd5a7061a113e21.svg";
export { ForwardRef as ReactComponent };